<template>
  <EditorCore
    ref="core"
    :editable="editable"
    :autofocus="autofocus"
    :placeholder="placeholder"
    :content="content"
    :content-type="contentType"
    v-bind="extensionBinding"
    @update:content="emit('update:content', $event)"
  />
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent, ref } from "vue";

const EditorCore = defineAsyncComponent(() => import("./TipTapEditorCore.vue"));

type Props = {
  extensions?: unknown[];
  editable?: boolean;
  autofocus?: boolean;
  /** Placeholder of the default extensions. */
  placeholder?: string;
  content?: string | null;
  contentType?: "markdown" | "html";
};

const props = withDefaults(defineProps<Props>(), {
  editable: true,
  autofocus: false,
  content: "",
  contentType: "markdown",
});

const emit = defineEmits<{
  "update:content": [value?: string | null];
}>();

const extensionBinding = computed(() => (props.extensions ? { extensions: props.extensions } : {}));

type EditorHandle = {
  editor?: {
    commands: {
      insertContent: (content: string) => void;
    };
  };
};

const core = ref<EditorHandle | null>(null);

defineExpose({
  editor: computed(() => core.value?.editor),
});
</script>
